export const ROUTES = {
    // Auth
    Login: "/login",
    ConfirmOtp: "/confirm-otp",

    // Profile
    Profile: "/profile",
    ProfileAccount: "/profile/account",
    ProfileChangePhone: "/profile/change-phone",

    // Main
    AssignmentsPage: "/assignments",
    Dashboard: "/",
    MyRoute: "/my-route",

    // Work plan
    WorkPlan: "/work-plan",
    WorkPlanUnplannedPoint: "/work-plan/unplanned-point",

    // Point details
    PointAddContract: "/addContract/:pointId",
    PointContractDetail: "/work-plan/details/:pointId/contracts/:contractId",
    PointContracts: "/work-plan/details/:pointId/contracts",
    PointDetails: "/work-plan/details/:pointId",
    PointPlan: "/work-plan/details/:pointId/plan",
    PointShelves: "/work-plan/details/:pointId/shelves",
    ProductPage: "/work-plan/product-card/:barcode",
    MarketVerifyAddress: "/work-plan/details/:pointId/verify-address/:marketId",

    // Tasks
    AddPhotoTask: "/work-plan/:pointId/addPhoto/:taskId",
    AssignmentTask: "/work-plan/:pointId/customTask/:taskId",
    AssortmentMatrix: "/work-plan/:pointId/assortmentMatrix/:taskId",
    DMP: "/work-plan/:pointId/dmp/:taskId",
    PaidShelfSpaceTask: "/work-plan/:pointId/paidShelfSpace/:taskId",
    PromoTagPhotos: "/work-plan/:pointId/promoTagPhotos/:taskId",
    RejectProductsTask: "/work-plan/:pointId/rejectProducts/:taskId",
    SaleAdditionalPromoTask: "/work-plan/:pointId/saleAdditional/:taskId/promo",
    SaleAdditionalTask: "/work-plan/:pointId/saleAdditional/:taskId",
    SetGeoLocationTask: "/work-plan/:pointId/setGeoLocation/:taskId",
    ShelfSizeTask: "/work-plan/:pointId/ShelfSize/:taskId",
    TakeDebtTask: "/work-plan/:pointId/takeDebt/:taskId",
    UpdateMarketInfoTask: "/work-plan/:pointId/updateMarketInfo/:taskId",
    UpdateProductBalancesTask:
        "/work-plan/:pointId/updateProductBalances/:taskId",

    // Checkout
    Checkout: "/checkout",
    CheckoutAddProducts: "/:isCheckout/:pointId/addProducts/:orderId",
    CheckoutOrderDetails: "/checkout/:orderId/order-details",
    SVCheckout: "/sv-checkout",
    SVCheckoutRoute: "/sv-checkout/:routeId",

    // SV
    NewRoutePointCreate: "/route-management-sv/new-route/create-point",
    RouteManagement: "/route-management-sv",
    RouteManagementAddPoint: "/route-management/add-point/:routeId",
    RouteManagementCreate: "/route-management-sv/new-route",
    RouteManagementCreateAddPoint: "/route-management-sv/new-route/add-point/",
    RouteManagementDaysView: "/route-management-sv/:routeId/days",
    RouteManagementEdit: "/route-management-sv/:routeId",
    RouteManagementMyRoute: "/route-management/my-route",
    Team: "/team",
    TeamUserDetail: "/team/:userId",
    WorkPlanSV: "/work-plan-sv",

    // HR
    HRTeam: "/team-hr",
};
